import http from './httpClient';
const fallBackData = {
  title: 'CIT Cloud Management Dashboard',
  templating: [],
  rows: [
    {
      title: 'Dashboard Unavailable',
      panels: [],
    },
  ],
};

const MonitoringMs = {
  getDashboard: async (dashboardId: string) => {
    try {
      return await http.get(`${import.meta.env.VITE_MONITORING_V1_BASE}/dashboard/${dashboardId}`);
    } catch (error: unknown) {
      console.error(`Failed to fetch dashboard ${dashboardId}:`, error);
      return {
        data: fallBackData,
        statusText: 'Bad Request - Fallback Data',
        status:
          (
            error as {
              status?: number;
            }
          ).status ?? 400,
      };
    }
  },

  getPanel: async (data: Record<string, unknown>, dashboardId: string) => {
    try {
      return await http.post(`${import.meta.env.VITE_MONITORING_V1_BASE}/panel`, {
        ...data,
        dashboardId,
      });
    } catch (error) {
      console.error(`Failed to fetch panel for dashboard ${dashboardId}:`, error);
      return {
        data: { error: 'Panel data unavailable', panels: [] },
        statusText: 'Bad Request',
        status:
          (
            error as {
              status?: number;
            }
          ).status ?? 400,
      };
    }
  },
};

export default MonitoringMs;
